import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from './AuthProvider';

export function RequireAuth() {
  const { ready, loading, user } = useAuth();
  const location = useLocation();

  if (loading || !ready) {
    return (
      <div className="boot-screen" role="status" aria-live="polite">
        <div className="boot-spinner" />
      </div>
    );
  }

  if (!user) {
    const redirect = `${location.pathname}${location.search}`;
    return <Navigate to={`/login?redirect=${encodeURIComponent(redirect)}`} replace />;
  }

  return <Outlet />;
}
